import type { DropType, SimulationEvent } from './sim/types';

const DROP_FREQUENCY: Record<DropType, number> = {
  attractor: 330,
  deflector: 220,
  speed: 520,
  explosion: 90,
  surge: 165,
};

export class AudioEngine {
  private context: AudioContext | null = null;

  constructor(public enabled: boolean) {}

  unlock(): void {
    if (!this.enabled) return;
    this.context ??= new AudioContext();
    void this.context.resume();
  }

  play(events: readonly SimulationEvent[]): void {
    if (!this.enabled || !this.context) return;
    for (const event of events) {
      if (event.type === 'delivery') this.tone(740, 0.05, 0.025);
      else if (event.type === 'drop' && event.drop) this.tone(DROP_FREQUENCY[event.drop], 0.08, 0.035);
      else if (event.type === 'explosion') this.tone(70, 0.2, 0.08, 'sawtooth');
      else if (event.type === 'core-hit') this.tone(120, 0.03, 0.018, 'square');
      else if (event.type === 'finish') this.tone(event.team === 0 ? 660 : 150, 0.5, 0.06);
    }
  }

  private tone(frequency: number, duration: number, volume: number, type: OscillatorType = 'sine'): void {
    if (!this.context) return;
    const oscillator = this.context.createOscillator();
    const gain = this.context.createGain();
    const now = this.context.currentTime;
    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, now);
    gain.gain.setValueAtTime(volume, now);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
    oscillator.connect(gain).connect(this.context.destination);
    oscillator.start(now);
    oscillator.stop(now + duration);
  }
}
